import styled from 'styled-components/macro';
import { deviceMin } from 'utils/styles/breakpoints';
import { COLORS } from 'utils/styles/colors';
import { FONTS, FONT_FAMILY } from 'utils/styles/fonts';
import { Images } from 'assets/images';
import { FLEX_CONTAINER } from 'utils/styles/flex';

export const ContentContainer = styled.div`
  ${FLEX_CONTAINER.FlexCenterColumn}
  background-image: url(${Images.waitingBack});
  background-repeat: no-repeat;
  background-size: cover;
  ${FLEX_CONTAINER.FlexCenterColumn}
  position: relative;
  z-index: 1;

  @media ${deviceMin.mobileS} {
    height: 240px;
  }

  @media ${deviceMin.mobileL} {
    height: 285px;
  }

  @media ${deviceMin.tablet} {
    margin-bottom: 0px;
    height: 389px;
  }

  @media ${deviceMin.laptopL} {
    height: 659px;
  }

  @media ${deviceMin.desktop} {
    height: 988px;
  }
`;

export const WaitingTitle = styled.p`
  ${FONT_FAMILY.FontBold}
  ${FONTS.font36}
color: ${COLORS.white};

  @media ${deviceMin.mobileS} {
    display: none;
  }

  @media ${deviceMin.tablet} {
    ${FONTS.font20}
    display: block;
    margin-top: 70px;
  }

  @media ${deviceMin.laptopL} {
    margin-top: 0px;
    ${FONTS.font28}
  }

  @media ${deviceMin.desktop} {
    ${FONTS.font36}
  }
`;

export const WaitingsubTitle = styled.p`
  ${FONTS.font24}
  color: ${COLORS.white};
  margin-top: 60px;
  width: 55%;
  text-align: center;

  @media ${deviceMin.mobileS} {
    display: none;
  }

  @media ${deviceMin.tablet} {
    ${FONTS.font16}
    display: block;
    width: 60%;
    margin-top: 16px;
  }

  @media ${deviceMin.laptopL} {
    ${FONTS.font20}
    margin-top: 45px;
  }

  @media ${deviceMin.desktop} {
    ${FONTS.font24}
    margin-top: 60px;
  }
`;
